import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { api } from '../../../services/api.js';
import Swal from 'sweetalert2';

const CardapioPopup = ({ usuario, restaurante, onClose, onConfirm, onCancelar }) => {
  const [cardapio, setCardapio] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [opcao, setOpcao] = useState('');
  const [loja, setLoja] = useState('');
  const [turno, setTurno] = useState('0');
  const [observacao, setObservacao] = useState('');
  const [tipoRefeicao, setTipoRefeicao] = useState('');

  const limparCampos = () => {
    setOpcao('');
    setLoja('');
    setTurno('0');
    setObservacao('');
    setTipoRefeicao('');
  };

  useEffect(() => {
    const lojaUsuario = localStorage.getItem("loja");
    limparCampos();

    if (restaurante) {
      api.get(`/restaurante/${usuario}/cardapio?codigo=${restaurante.codigo}`)
        .then(res => {
          if (Array.isArray(res.data)) setCardapio(res.data);
          else setCardapio([]);
        })
        .catch(() => setCardapio([]));

      api.get(`/restaurante/${usuario}/loja?loja=${lojaUsuario}&codigo=${restaurante.codigo}`)
        .then(res => setLojas(Array.isArray(res.data) ? res.data : []))
        .catch(() => setLojas([]));
    }
  }, [restaurante]);

  const handleEnviar = async () => {
    const lojaSelecionada = lojas.find(l => l.loja == loja);
    const payload = {
      usuario,
      acao: 'INSERIR',
      codigo: restaurante.codigo,
      marmitex: tipoRefeicao === 'M' ? '1' : '0',
      opcao: tipoRefeicao === 'M' ? opcao : '',
      observacao,
      status: 0,
      valor: lojaSelecionada?.valor,
      loja,
      turno
    };

    try {
      const res = await api.post(`/restaurante/${usuario}`, payload);
      if (res.status === 201) {
        Swal.fire('Pedido enviado!', 'Seu pedido foi registrado com sucesso.', 'success');
        onConfirm({ restaurante, ...payload });
        onClose();
      } else {
        Swal.fire('Erro', res.data?.mensagem || 'Erro ao registrar pedido', 'error');
      }
    } catch (err) {
      let msg = 'Falha na comunicação com o servidor';
      if (err.response?.data?.erro) {
        msg = Array.isArray(err.response.data.erro)
          ? err.response.data.erro[0]
          : err.response.data.erro;
      }
      Swal.fire('Erro', msg, 'error');
    }
  };

  const lojaSelecionada = lojas.find(l => l.loja == loja);
  const permiteMarmitex = lojaSelecionada?.marmitex === 1;

  return (
    <Modal
      show={!!restaurante}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className="d-flex flex-column" style={{ height: '90vh' }}>
        <Modal.Header closeButton>
          <Modal.Title>
            {restaurante?.nomeamigavel}
          </Modal.Title>
        </Modal.Header>

        {/* BODY COM SCROLL */}
        <Modal.Body style={{ overflowY: 'auto', flex: 1 }}>
          <Form>
            {/* LOJA */}
            <Form.Group className="mb-3">
              <Form.Label>Loja</Form.Label>
              <Form.Select value={loja} onChange={e => setLoja(e.target.value)}>
                <option value="">Selecione</option>
                {lojas.map(l => (
                  <option key={l.loja} value={l.loja}>
                    Loja {String(l.loja).padStart(2, '0')}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* TIPO REFEIÇÃO */}
            {permiteMarmitex && (
              <Form.Group className="mb-3">
                <Form.Label>Tipo de Refeição</Form.Label>
                <Form.Select value={tipoRefeicao} onChange={e => setTipoRefeicao(e.target.value)}>
                  <option value="">Selecione</option>
                  <option value="M">Marmitex</option>
                  <option value="R">Restaurante</option>
                </Form.Select>
              </Form.Group>
            )}

            {/* CARDÁPIO */}
            <Form.Group className="mb-3">
              <Form.Label>Cardápio</Form.Label>
              <div className="border p-2 bg-light" style={{ maxHeight: 220, overflowY: 'auto' }}>
                {cardapio.map(item => (
                  tipoRefeicao === 'M' && permiteMarmitex ? (
                    <Form.Check
                      type="radio"
                      name="opcao"
                      id={`opcao-${item.opcao}`}
                      key={item.opcao}
                      value={item.opcao}
                      checked={opcao === String(item.opcao)}
                      onChange={e => setOpcao(e.target.value)}
                      label={<><strong>{item.opcao}</strong> - {item.menu}</>}
                    />
                  ) : (
                    <div key={item.opcao} className="py-1">
                      <strong>{item.opcao}</strong> - {item.menu}
                    </div>
                  )
                ))}
              </div>
            </Form.Group>

            {/* TURNO */}
            {tipoRefeicao === 'M' && (
              <Form.Group className="mb-3">
                <Form.Label>Turno</Form.Label>
                <Form.Select value={turno} onChange={e => setTurno(e.target.value)}>
                  <option value="0">1º Turno</option>
                  <option value="1">2º Turno</option>
                </Form.Select>
              </Form.Group>
            )}

            {/* OBSERVAÇÃO */}
            <Form.Group className="mb-3">
              <Form.Label>Observação</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={observacao}
                onChange={e => setObservacao(e.target.value)}
                placeholder="Ex: Sem cebola, caprichar na farofa..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        {/* FOOTER FIXO */}
        <Modal.Footer className="border-top bg-white">
          <Button variant="secondary" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleEnviar}
            disabled={
              !loja ||
              (permiteMarmitex && tipoRefeicao === 'M' && !opcao)
            }
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default CardapioPopup;